import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core'
import { AudienceInfo } from 'src/app/models/audience.model'

@Component({
  selector: 'app-audience-column-chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-card>
      <mat-card-content>
        <mat-list>

          <div>
            <div
              fxLayout="row wrap"
              fxLayoutGap="8px"
              fxLayoutAlign="start center"
            >
              <div mat-subheader>
                {{ chartName }}
              </div>

              <div fxFlex="1 1 auto"></div>

              @if (help) {
                <mat-icon
                  class="help"
                  [matTooltip]="help"
                >
                  help_outline
                </mat-icon>
              }

              <div fxLayoutAlign="right end">
                @if (!dataCollectLoading) {
                  @if (dataCollections) {
                    <img
                      class="datafix_icon"
                      matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
                      src="./assets/data_collections.png"
                    />
                  } @else {
                    <img
                      class="datanofix_icon"
                      src="./assets/data_collections.png"
                    />
                  }
                } @else {
                  <img
                    class="datanofix_icon"
                    src="./assets/data_collections.png"
                  />
                }
              </div>
            </div>

            <div
              #chartContainer
              class="chart-wrapper"
            >
              @if (chartWidth > 0) {
                <google-chart
                  class="chart"
                  type="ColumnChart"
                  [data]="info"
                  [columns]="columnNames"
                  [options]="options"
                  [width]="chartWidth"
                  [height]="350"
                >
                </google-chart>
              }
            </div>
          </div>

        </mat-list>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./audience-column-chart.component.scss'],
  standalone: false,
})
export class AudienceColumnChartComponent
  implements AfterViewInit, OnDestroy {
  @ViewChild('chartContainer')
  chartContainer!: ElementRef<HTMLElement>

  @Input()
  chartName!: string

  @Input()
  help!: string

  @Input()
  info: AudienceInfo[] = []

  @Input()
  columnNames: string[] = []

  @Input()
  options: object = {}

  @Input()
  dataCollections = false

  @Input()
  dataCollectLoading = true

  chartWidth = 0

  private resizeObserver?: ResizeObserver

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.updateChartWidth()

    this.resizeObserver = new ResizeObserver(() => {
      this.updateChartWidth()
    })

    this.resizeObserver.observe(
      this.chartContainer.nativeElement
    )
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect()
  }

  private updateChartWidth(): void {
    if (!this.chartContainer) {
      return
    }

    const width =
      this.chartContainer.nativeElement.clientWidth

    if (width <= 0 || width === this.chartWidth) {
      return
    }

    this.chartWidth = width
    this.cdr.detectChanges()
  }
}
